import { observable, computed, action } from 'mobx';

class VideoStore {
  @observable videos = [];
  @observable width;
  @observable height;
  @observable addDialogOpen = false;
  @observable editMode = false;

  @action pushVideo(video) {
    if (this.videos.length < 4 &&
      this.videos.find((elem) => { return elem === video }) === undefined
    ) {
      this.videos.push(video);
    }
    this.handleAddClose();
  }

  @action handleAddOpen = () => {
    console.log('adding video');
    this.addDialogOpen = true;
  }

  @action handleAddClose = () => {
    console.log('closing dialog');
    this.addDialogOpen = false;
  }

  @action updateWindowDimensions(width, height) {
    this.width = width;
    this.height = height;
  }
}

export default new VideoStore();


// WEBPACK FOOTER //
// ./src/stores/videoStore.js